import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../components/Loader';
import { fetchInvoice } from '../../actions';
import { selectInvoice } from '../../selectors';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_INVOICE, REQUEST_INVOICE_EMAIL } from '../../constants';
import { VBox, HBox } from '../../../../components/Box';
import { CardCompanyHeader } from '../../../Companies/components/CardCompanyHeader';
import { SendToEmailModal } from './SendToEmailModal';
import { VehicleHeaderV2Design } from '../../../Vehicles/components/VehicleHeaderV2Design';
import { performAction, toggleKanbanCompanyModal } from '../../../KanbanBoards/actions';

const Container = styled.div`
  position: relative;
  width: 100%;

  box1 {
    h2 {
      font-size: 16px;
      text-transform: uppercase;
    }
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class SendToEmailComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchInvoice(result => {});
  }

  componentDidUpdate(prevProps, prevState) {}

  render() {
    if (this.props.workInvoice || this.props.workMailing) return <Loader small />;
    const outgoingInvoice = this.props.outgoingInvoice;

    return (
      <Container innerWidth={window.innerWidth}>
        <HBox vCenter className={'box1'} style={{ height: '60px' }}>
          {!this.props.title === false && <h2>{this.props.action?.functionName}</h2>}
        </HBox>
        {this.props.action?.functionName == 'FIN_final_invoice_no_mail' && (
          <VBox>
            <VehicleHeaderV2Design wide vehicle={this.props.vehicle} />
            <CardCompanyHeader bottomStatus company={this.props.outgoingInvoice?.outgoingCompany} />
          </VBox>
        )}
        <SendToEmailModal
          topButton
          invoice={outgoingInvoice}
          actionFunctionName={this.props.action?.functionName}
          userCreatorId={outgoingInvoice?.userCreatorId}
          financialContactId={outgoingInvoice?.financialContactId}
          outgoingUserId={outgoingInvoice?.outgoingUserId}
          emailContactId={outgoingInvoice?.emailContactId}
          performAction={() => this.props.confirm(() => this.props.oncloseModal())}
        />
      </Container>
    );
  }
}

SendToEmailComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    outgoingInvoice: selectInvoice(ownProps.outgoingInvoiceId),
    workInvoice: selectWork(REQUEST_INVOICE),
    workMailing: selectWork(`${REQUEST_INVOICE_EMAIL}-${ownProps.outgoingInvoiceId}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchInvoice(callback) {
      dispatch(fetchInvoice(ownProps.outgoingInvoiceId, callback));
    },
    confirm(callback) {
      dispatch(
        performAction(
          ownProps.action?.id,
          ownProps.vehicle?.id,
          { regplate_code: ownProps.vehicle?.regplate_code || '' },
          callback,
        ),
      );
    },
    oncloseModal() {
      dispatch(toggleKanbanCompanyModal());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SendToEmail = compose(withConnect, withRouter)(SendToEmailComp);
